<template>
   <iframe :src="url" width="100%" height="100%"></iframe>
</template>

<script>
export default {
  name:"FrameRegisterPage",
  data() {
    return {
      url: "",
    };
  },
  created() {
    this.url = this.$route.query.url || "";
  },
  mounted() {
    window.addEventListener("message", function (event) {
      event.preventDefault();
      try {
        if( event.data.method === "redirect") {
          this.window.location = "/register?step=1&" + event.data.url;
        }
      } catch(e) {
        console.log(e)
      }
    });
  },
}
</script>